module.exports = __webpack_public_path__ + "static/media/preview-thumbnail-9.603f102e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pseudodocs/preview-thumbnail-9.jpg
// module id = 1895
// module chunks = 2